import { Box, Typography } from "@mui/material";
import React from "react";

const FooterOnPage = () => {

    return (
        <footer>
            <Box
                sx={{ my: 3 }}
            >
                <div className="flex-row note">
                    <Typography variant="subtitle2">
                        created by&nbsp;
                    </Typography>
                    <Typography variant="subtitle2">
                        <a href="https://github.com/roso1nik" target="_blank" rel="noreferrer noopener">roso1nik</a>
                    </Typography>
                </div>
                <Typography variant="subtitle2" className="note">
                    ?ILNP❤
                </Typography>
            </Box> 
        </footer>
    )
}

export default FooterOnPage;